import intl from 'react-intl-universal';
import { OldGoodType } from '@/type/components';
import getEnumLabel from '@/utils/getEnumLabel';
import { useModel } from '@umijs/max';
import { Row, Col, Image } from 'antd';
import { default as Button } from '@/components/CssBtn';

import styles from './index.less';

type OldGoodProps = {
    title: string;
    good?: OldGoodType;
    editGood: () => void;
    disable: boolean;
    orderCreatedTime?: string;
    aftersaleType: number;
};

//aftersaleType--1: '换货',2: '仅退款',3: '退货退款',4: '维修', 5: '补券',6: '补发配件',
const OldGood: React.FC<OldGoodProps> = ({
    title,
    good,
    editGood,
    disable,
    orderCreatedTime,
    aftersaleType,
}) => {
    const global = useModel('global');
    const handelReason = (arr: any) => {
        return arr?.length && arr.map((obj) => obj.reason_value).join(',');
    };

    const compareTime = () => {
        const compareDate = new Date('2024.02.27 06:00:00').getTime();
        const orderCreated = new Date(orderCreatedTime).getTime();
        if (!orderCreatedTime || compareDate - orderCreated < 0) {
            switch (aftersaleType) {
                case 1:
                    return global.workOrderEnums.newProblemPositionEnum;
                case 100:
                    return global.workOrderEnums.refundProblemPosEnum;
                case 4:
                    return global.workOrderEnums.repairProblemPosEnum;
                case 5:
                    return global.workOrderEnums.couponProblemPosEnum;
            }
        } else {
            return global.workOrderEnums.problemPositionEnum; //早于工单创建时间，用problemPositionEnum
        }
    };

    return (
        <div className={styles.goodWrap}>
            <div>{title}</div>
            <div className={styles.right}>
                {good ? (
                    <div className={styles.contentWrap}>
                        <div className={styles.content}>
                            <Row>
                                <Col>{intl.get('系列名称：')}</Col>
                                <Col>{good.seriesName}</Col>
                            </Row>
                            <Row>
                                <Col>{intl.get('商品名称：')}</Col>
                                <Col>{good.productName}</Col>
                            </Row>
                            <Row>
                                <Col>{intl.get('售后原因：')}</Col>
                                <Col>{handelReason(good.first_reasons)}</Col>
                            </Row>
                            <Row>
                                <Col>{intl.get('瑕疵原因：')}</Col>
                                <Col>{handelReason(good.second_reasons)}</Col>
                            </Row>
                            <Row>
                                <Col>{intl.get('瑕疵部位：')}</Col>
                                <Col>
                                    {getEnumLabel(
                                        compareTime(),
                                        good.problemPos,
                                    ) || '-'}
                                </Col>
                            </Row>
                            <Row>
                                <Col>{intl.get('瑕疵图片：')}</Col>
                                <Col>
                                    <Row gutter={1}>
                                        {good.images &&
                                            good.images.map((url, index) => {
                                                return (
                                                    <Image
                                                        key={index}
                                                        width={40}
                                                        height={40}
                                                        src={url}
                                                    />
                                                );
                                            })}
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <a
                            onClick={editGood}
                            style={{
                                visibility: disable ? 'hidden' : 'visible',
                            }}
                        >
                            {intl.get('编辑')}
                        </a>
                    </div>
                ) : disable ? (
                    '-'
                ) : (
                    <Button onClick={editGood}>{intl.get('添加商品')}</Button>
                )}
            </div>
        </div>
    );
};

export default OldGood;
